import tick_pro from "../../../assets/images/tick_pro.svg";
import { IoCloseOutline } from "react-icons/io5";
import { Divider } from "@mui/material";

export default function ChoseKeyavo() {
  return (
    <div className="w-full flex flex-col gap-3">
      <div className="w-full rounded-[8px] bg-[#1C9BDB] h-[72px] px-[8px] py-[6px] flex gap-4 items-center">
        <div className="w-[54px] h-[54px] rounded-full bg-[#E1F7FF] flex items-center justify-center ">
          <p>03</p>
        </div>
        <div>
          <p className="w-[200px] text-[20px] font-semibold text-white lg:text-[28px] lg:font-semibold lg:whitespace-nowrap">
            Sản phẩm dầu bơ ép lạnh - KeyAvo
          </p>
        </div>
      </div>
      <div className="w-full bg-[#E4F7FF] h-[97px] lg:h-[52px] lg:rounded-[30px] rounded-[16px] px-[16px] py-[8px] lg:px-[20px]">
        <div className="flex items-center justify-around lg:flex lg:items-center lg:justify-between gap-2">
          <div>
            <p className="w-[100px] lg:text-[24px] font-semibold text-[#1C9BDB] lg:whitespace-nowrap">
              Ưu điểm
            </p>
          </div>
          <div className="flex items-center justify-between w-[130px] lg:w-[200px] gap-5">
            <p className="w-[89px] lg:whitespace-nowrap relative lg:right-[270px] lg:text-[24px] font-semibold lg:text-[#1C9BDB] ">
              KeyAvo
            </p>
            <p className="w-[58px] lg:whitespace-nowrap relative lg:right-[230px] lg:text-[24px] font-semibold lg:text-[#1C9BDB]   ">
              Sản phẩm khác
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Tốt cho sức khoẻ của bé
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              Dầu bơ có nhiều thành phần dinh dưỡng vào thức ăn dặm, giúp phát
              triển não bộ và tăng cường sức khỏe tổng thể.
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Divider />
      </div>
      <div className="bg-[#FAFAFA]">
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Làm giảm nguy cơ mắc bệnh tim
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              . Các axit béo không bão hòa đơn và sterol thực vật có trong dầu
              bơ giúp duy trì cân bằng cholesterol HDL "tốt" và LDL "xấu", giảm
              triglyceride.
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              . Giảm nguy cơ mắc bệnh tim, tăng cường khả năng chống viêm.
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Divider />
      </div>
      <div>
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Ngăn ngừa lão hoá, giảm viêm khớp
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              .Chống oxy hóa, bảo vệ cơ thể khỏi tác hại của lão hóa.
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              . Bảo vệ não bộ, giảm nguy cơ Alzheimer và các rối loạn nhận thức
              khác.
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              . Giảm đau và cứng khớp do thoái hóa khớp, đặc biệt hiệu quả với
              thoái hóa khớp háng và đầu gối.
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Divider />
      </div>
      <div className="bg-[#FAFAFA]">
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Cải thiện sức khoẻ về mắt
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              Các hợp chất carotenoid, gồm lutein và zeaxanthin trong dầu bơ rất
              tốt cho thị lực, đặc biệt là giúp giảm sự thoái hóa điểm vàng
              trong mắt.
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Divider />
      </div>
      <div className="">
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Bảo vệ da, ngăn ngừa tổn thương da
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              Nhờ vào hàm lượng vitamin E cao, dầu bơ giúp bảo vệ lớp biểu bì và
              có tác dụng chống oxy hóa. Sử dụng dầu bơ thường xuyên đặc biệt
              hữu ích trong việc ngăn ngừa các tổn thương da và giảm các tác
              động của sự lão hóa da.
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Divider />
      </div>
      <div className="bg-[#FAFAFA]">
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Hỗ trợ giảm cân
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              Dầu bơ có chứa hàm lượng axit oleic rất cao giúp tăng cường hoạt
              động thể chất và quá trình trao đổi chất sau bữa ăn, hỗ trợ hiệu
              quả cho quá trình giảm cân.
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Divider />
      </div>
      <div className="">
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Ngăn ngừa & điều trị trứng cá
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              Vì dầu bơ giữ cho da ngậm nước mà không quá nhờn, do đó làm giảm
              nguy cơ bị mụn trứng cá.
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Divider />
      </div>
      <div className="bg-[#FAFAFA]">
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Giảm nếp nhăn & quầng thâm mắt
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              Vitamin A và E có nhiều trong dầu bơ có khả năng xâm nhập vào lớp
              thứ hai của da, giúp làm giảm quầng thâm và nếp nhăn da vùng mắt,
              cải thiện màu da tối.
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Divider />
      </div>
      <div className="">
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Dưỡng tóc
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              Với thành phần dầu cao, dầu bơ giúp tóc mềm mượt, kích thích mọc
              tóc. Kết hợp với những hoạt chất chống viêm, dầu bơ giúp làm sạch
              da dầu và giảm tóc gãy rụng một cách hiệu quả.
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
